import { useTranslation } from "react-i18next"
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from "react"
import { EvidenceDataHook } from "../../../../../../../hooks/evidences/typyng"
import { InputModel } from "../../../../../../../utils/types"
import { useFilter } from "../../../../../../../hooks/filter"
import { loogbookServiceFetch } from "../../../../../../../utils/constants/callService"
import { returnQuery, returnQueryWithPagination } from "../../../../../../../utils/methods/returnQuery"
import { formatActivitiesListResponse, formatActivityByIdResponse, questiononEvidencesToEvidenceData } from "../../../../../../../service/logbook/format"
import { Types } from "../../../../../../../utils/enums"
import { useStyles } from "../styles"
import { ClickPayload, Settings } from "../../../../../../../components/settings"
import { ItemMenu } from "../../../../../../../components/baseMenu"
import { useDownload } from "../../../../../../../hooks/download/useDownload"


const useTables = ({
  setCanEdit,
  evidencesActivity,
  handledataCrud,
  setopenField
}: {
  setCanEdit: Dispatch<SetStateAction<boolean>>,
  evidencesActivity: EvidenceDataHook,
  handledataCrud: (data?: Record<string, unknown>) => void,
  setopenField: React.Dispatch<React.SetStateAction<boolean>>
}) => {

  const { t } = useTranslation()
  const refTime = useRef<NodeJS.Timeout | null>(null)
  const styles = useStyles()
  const [settingData, setSettingData] = useState<ClickPayload>()
  const [loading, setLoading] = useState({
    table: false,
    createOrUpdate: false,
    search: false
  })
  const [totalPages,  setTotalPages] = useState(0)

  const menu: ItemMenu[] = [
    { label: t('general.delete'), value: 1 },
    { label: t('general.edit'), value: 2 },
  ];

  const [inputCrud, setInputCrud] = useState<{ [x: string]: InputModel }>({
    activityName: {
      label: 'loogbook.inputs.activityName',
      translate: true,
      name: 'activityName',
      type: 'text',
      validate: {
        required: true,
      },
      rest: {
        type: 'alphaNumeric',
        inputProps: {
          maxLength: 100,
        },
      },
      value: null,
      size: {
        lg: 12,
        md: 12,
        sm: 12,
        xl: 12,
        xs: 12
      }
    },
  })



  const [inputFilter, setInputFilter] = useState<{ [x: string]: InputModel }>({
    search: {
      label: 'general.search',
      translate: true,
      name: 'search',
      value: null,
    },
    from: {
      label: 'general.tags.from',
      translate: true,
      name: 'from',
      type: 'date',
      value: null,
      rest: {
        max: 'to',
      },
      size: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6,
      },
    },
    to: {
      label: 'general.tags.to',
      translate: true,
      name: 'to',
      type: 'date',
      value: null,
      rest: {
        min: 'from',
      },
      size: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6,
      },
    },
  })

  const formatFilter = {
    from: "start_date",
    to: 'end_date',
  }

  const filter = useFilter({
    formatFilter,
  })

  const [openModal, setOpenModal] = useState<{
    open: boolean
    title: string
    description: string
    id: string | number
    confirm?: () => void
  }>({
    id: '',
    open: false,
    title: '',
    description: '',
  })

  const [openSnackbar, setOpenSnackbar] = useState({
    open: false,
    type: Types.SUCCESS,
    message: ''
  })

  const closeSnackbar = () => { setOpenSnackbar(prev => ({ ...prev, open: false })) }

  const closeModal = () => {
    setOpenModal((prev) => ({
      ...prev,
      open: false,
      confirm: undefined
    }))
  }

  const click = (payload: ClickPayload) => {
    setSettingData(payload)
  }

  const closeMenu = () => {
    setSettingData(undefined)
  }

  const optionMenu = ({ item }: { item: ItemMenu }) => {

    if (item.value == 1) {
      if (settingData?.id) {
        deleteActivity({ id: settingData?.id });
      }
      return;
    }

    if (item.value == 2) {
      if (settingData?.id) {
        getActivityDetail({ id: settingData?.id })
      }
      return;
    }

  }

  const deleteActivity = async ({ id }: { id: string }) => {
    setOpenModal((prev) => ({
      ...prev,
      open: true,
      title: t('loogbook.modal.deleteActivityTitle'),
      description: t('loogbook.modal.deleteActivityDescription'),
      confirm: async () => {
        try {
          const response = await loogbookServiceFetch.deleteActivity(id);

          if (!response?.errors) {
            closeModal();
            setOpenSnackbar((prev) => ({
              ...prev,
              open: true,
              type: Types.SUCCESS,
              message: t('loogbook.snackbar.catalog.delete.success'),
            }));
            getActivities();
          } else {
            setOpenSnackbar((prev) => ({
              ...prev,
              open: true,
              type: Types.ERROR,
              message: t('loogbook.snackbar.catalog.delete.error'),
            }));
          }
        } catch (error) {
          setOpenSnackbar((prev) => ({
            ...prev,
            open: true,
            type: Types.ERROR,
            message: t('loogbook.snackbar.catalog.delete.error'),
          }));
        } finally {
          closeModal();
        }
      }
    }))
  }

  const [row, setRow] = useState<{
    id: number,
    title: String,
    createTime: Date | null,
    updateTime: Date | null,
    deleteTime: Date | null,
    activityCount: number
  }[]>([])

  const column = [
    {
      id: 'title',
      label: t('loogbook.columns.activityName'),
      sortable: true,
      /* headerCell: styles?.headerTableActions, */
    },
    {
      id: 'activityCount',
      label: t('loogbook.columns.numberOfRecords'),
      sortable: true,
      /* headerCell: styles?.headerTableActions, */
    },
    {
      id: 'actions',
      label: t('general.tags.action'),
      /* headerCell: styles?.headerTableActions, */
      renderCell: ({ row:rowCopy }: any) => {
        return (
          <Settings
            row={rowCopy}
            click={click}
            rowLength={row.length}
            /* disable={row.execution == 0} */
          />
        );
      },
    },

  ]

  const getActivities = async () => {
    setLoading(prev => ({
      ...prev,
      table: true
    }))

    const response = await loogbookServiceFetch.getTableActivities({ query: returnQuery({ ...filter.query, filter: filter.query.filter?.replaceAll('+', '%2B') }, formatFilter) })

    const { row, totalPages } = formatActivitiesListResponse({ response })

    setRow(row)
    setTotalPages(totalPages)

    setLoading(prev => ({
      ...prev,
      table: false
    }))
  }

  const queryv2 = returnQueryWithPagination({filter: filter.filterString,sort: filter.query?.sort,}, formatFilter).replace('&','')

  const downloadMain = useDownload({
    docName: t('loogbook.catalogueOfActivities'),
    query: queryv2,
    downloadFuntion: loogbookServiceFetch.downloadFile,
  })

  const getActivityDetail = async ({ id }: { id: string }) => {
    handledataCrud()
    evidencesActivity.fillData({ defaultValues: [] })
    setLoading(prev => ({
      ...prev,
      search: true
    }))

    evidencesActivity.clickOption({})
    setCanEdit(true)

    const response = await loogbookServiceFetch.getActivityById(Number(id))

    const { title, configEvidences, idActivity, openField } = formatActivityByIdResponse({ response })

    setopenField(openField)

    handledataCrud({
      "activityName": title,
      "idActivity": idActivity
    })


    evidencesActivity.fillData({ defaultValues: [questiononEvidencesToEvidenceData(configEvidences)] })


    setLoading(prev => ({
      ...prev,
      search: false
    }))
  }

  /* useEffect(() => {
    getActivities()
  }, []) */

  useEffect(() => {
    if (refTime.current) { clearTimeout(refTime.current) }

    refTime.current = setTimeout(() => {
      getActivities()
    }, 300)
  }, [filter.query.all])

  return { column, row, closeMenu, optionMenu, menu, settingData, downloadMain, inputCrud, totalPages, inputFilter, filter, loading, closeModal, openModal, openSnackbar, closeSnackbar, setOpenSnackbar, getActivities }
}

export { useTables }